import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Question } from 'portal/core/api/models/question.model';
import { ApiService } from 'portal/core/api/api.service';

export const questionsResolver: ResolveFn<Question[]> = () => inject(ApiService).getQuestions();
